module.exports = __webpack_public_path__ + "static/1.1.C. OLAR RANDARE 2-d09d8d2d2ee04c3826aa9e7059c47003.jpg";